import { render, staticRenderFns } from "./IdVerification.vue?vue&type=template&id=30090a6e&"
import script from "./IdVerification.vue?vue&type=script&lang=js&"
export * from "./IdVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports